import { useEffect, useState } from "react";
import Table from "../../components/GTable/Table";
import { GetPricesData, GetSettingsData } from "../../lib/data";
import Button from "../../components/GButton/Button";
import { pricesColumns } from "../../lib/definitions";
import { deletePricesForm, updateSettingsForm } from "../../lib/actions"; 
import DeleteRecord from "../../ui/Models/deleteRecord";
import TableSkeleton from "../../ui/sharedUi/tableSkeleton";
import i18n from "../../lib/i18n";

export default function Prices() {

    const [pricesData, setPricesData] = useState([]);
    const [openOrderSetting, setOpenOrderSetting] = useState(null); 
    const [deleteConfirmation, setDeleteConfirmation] = useState({ isOpen: false, idToDelete: null });
    const [isLoading, setIsLoading] = useState(true);  
    const [loadingDelete, setLoadingDelete] = useState(false);  

    // Popup State
    const [isSettingsOpen, setIsSettingsOpen] = useState(false);
    const [editValue, setEditValue] = useState("");
    const [loadingSettings, setLoadingSettings] = useState(false);

    const t = i18n.t.bind(i18n); 

    useEffect(() => {
        handleApi();
    }, [])

    const handleApi = async () => {
        setIsLoading(true);  
        const priceData = await GetPricesData();
        const settingData = await GetSettingsData();

        setPricesData([]);
        if(priceData?.data) {
             setPricesData(priceData.data);
        }

        // Extract the specific setting for 'open_order'
        if (settingData?.data) {
            const setting = settingData.data.find(item => item.key === 'open_order');
            if (setting) {
                setOpenOrderSetting(setting);
            }
        }

        setIsLoading(false);  
    };

    const openDeleteConfirmation = (id) => {
        setDeleteConfirmation({ isOpen: true, idToDelete: id });
    };

    const closeDeleteConfirmation = () => {
        setDeleteConfirmation({ isOpen: false, idToDelete: null });
    };

    const handelDelete = async () => {
        if (deleteConfirmation.idToDelete) {
            setLoadingDelete(true);
            const result = await deletePricesForm(deleteConfirmation.idToDelete);
            if (result) {
                setLoadingDelete(false);
                handleApi();
            }
            closeDeleteConfirmation();
        }
    };

    // --- Settings Popup Handlers ---

    const handleOpenSettings = () => {
        if (openOrderSetting) {
            setEditValue(openOrderSetting.value);
            setIsSettingsOpen(true);
        }
    };

    const handleSaveSettings = async () => {
        console.log("test");
        
        if (!openOrderSetting) return;

        setLoadingSettings(true);
        try {
            const payload = {
                settings: [
                    {
                        id: openOrderSetting.id,
                        value: editValue
                    }
                ]
            };

            // 2. Call the API with the payload object
            const result = await updateSettingsForm(payload);
            
            if (result) {
                setIsSettingsOpen(false);
                handleApi(); 
            }
        } catch (error) {
            console.error("Failed to update settings", error);
        } finally {
            setLoadingSettings(false);
        }
    };

    return (
        <div className="p-8 sm:p-6 md:p-8">
            <div className="flex flex-col sm:flex-row sm:items-baseline bg-thirdly justify-between px-5 py-5 gap-4">
                <h1 className="text-white text-lg ">{t("nav.delivery_price")}</h1>
                
                <div className="flex gap-3">
                    {/* Settings Button */}
                    {openOrderSetting && (
                        <div onClick={handleOpenSettings}>
                             <Button 
                                background="#3498db" 
                                borderRadius="8px" 
                                color="white" 
                                padding="8px 20px" 
                                text={t("button.open_order") || "Open Order Limit"} 
                            />
                        </div>
                    )}
                    
                    <Button background="#2F7A74" borderRadius="8px" color="white" padding="8px 20px" text={t("nav.add_delivery_price")} nav={"/prices/add"}  />
                </div>
            </div>
            
            <div>
                {isLoading ? <TableSkeleton cols={pricesColumns}/> : (  
                    <Table columns={pricesColumns} rows={pricesData} openDeleteConfirmation={openDeleteConfirmation} edit="/prices/edit" />
                )}  
            </div>

            {deleteConfirmation.isOpen && <DeleteRecord loadingDelete={loadingDelete} handelDelete={handelDelete} closeDeleteConfirmation={closeDeleteConfirmation} />}

            {/* Settings Popup Modal */}
            {isSettingsOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-thirdly rounded-lg shadow-lg w-full max-w-md p-6">
                        <h2 className="text-xl font-bold mb-4 text-white">
                            {t("nav.open_order") || "Edit Open Order"}
                        </h2>
                        
                        <div className="mb-6">
                            <input
                                type="text"
                                value={editValue}
                                onChange={(e) => setEditValue(e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        <div className="flex justify-end gap-3">
                            <button
                                onClick={() => setIsSettingsOpen(false)}
                                className="px-4 py-2 text-gray-600 bg-gray-200 rounded hover:bg-gray-300 transition"
                                disabled={loadingSettings}
                            >
                                {t("button.cancel") || "Cancel"}
                            </button>
                            <button
                                onClick={handleSaveSettings}
                                className="px-4 py-2 text-white bg-secondary rounded transition flex items-center gap-2"
                                disabled={loadingSettings}
                            >
                                {loadingSettings ? (
                                    <span>{t("button.save") || "Saving..."}</span>
                                ) : (
                                    <span>{t("button.save") || "Save"}</span>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};